var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCdIconPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "nc-icon glyph",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M23,0H1C0.4,0,0,0.4,0,1v22c0,0.6,0.4,1,1,1h22c0.6,0,1-0.4,1-1V1C24,0.4,23.6,0,23,0z M10,5 c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2S8,8.1,8,7C8,5.9,8.9,5,10,5z M18.2,19H5.9c-0.8,0-1.3-0.9-0.8-1.6L7.3,14c0.4-0.5,1.1-0.6,1.5-0.2 L11,16l3.1-3.9c0.4-0.5,1.3-0.5,1.6,0.1l3.3,5.3C19.5,18.1,19,19,18.2,19z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdIconPicture);
export default __webpack_public_path__ + "static/media/cd-icon-picture.52905a1ed43ea37387b9fe3f390d66fe.svg";
export { ForwardRef as ReactComponent };